import React, {useState} from 'react';
import {DateTimer} from "../../../partials/widgets/DateTimer";
import {Dropdown} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {isMute, setLocalSt, stKeys} from "../../../helpers/storage";
import {I18n} from "../../../i18n/KiloITi18n";

const IframeDropdownDesktopMenu = () => {

    const navigate = useNavigate();
    const param = useParams();
    const tableId = parseInt(param.id ?? "0");
    const [mute, setMute] = useState(isMute())

    const onChangeMute = () => {
        setMute(!mute);
        setLocalSt(stKeys.mute, mute ? "0" : "1");
    }

    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="text-light px-2 fs-6 fw-bolder">
                <DateTimer/>
            </div>
            <div className="ms-2" onClick={onChangeMute}>
                {
                    !mute ? <i className="bi bi-volume-up fs-1 cursor-pointer fw-bold"/> :
                        <i className="bi bi-volume-mute fs-1 cursor-pointer fw-bold"/>
                }

            </div>
            <Dropdown className="bg-transparent p-1">
                <Dropdown.Toggle className="bg-transparent">
                    <i className="bi bi-list fs-1 text-light"/>
                </Dropdown.Toggle>

                <Dropdown.Menu className="bg-light w-250px">
                    <Dropdown.Item onClick={() => navigate(`/report/${tableId}`)}
                                   className="border-bottom text-dark fw-bold fs-4 py-4">
                        <i className="fa-solid fa-file-text text-warning fs-2 me-4"/>
                        <span><I18n t={"REPORT"} /></span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default IframeDropdownDesktopMenu;